import { render, staticRenderFns } from "./PaymentFinalizationScreen.vue?vue&type=template&id=34667ea6&scoped=true&"
import script from "./PaymentFinalizationScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentFinalizationScreen.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFinalizationScreen.vue?vue&type=style&index=0&id=34667ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34667ea6",
  null
  
)

export default component.exports